import React from 'react';
import ReactDatepicker from 'react-datepicker';
import { createStyles, makeStyles, Theme } from '@material-ui/core';
import EventIcon from '@material-ui/icons/Event';
import 'react-datepicker/dist/react-datepicker.css'
import LoopIcon from '@material-ui/icons/Loop';

const useStyles = makeStyles((theme: Theme) =>createStyles({
  formWrapper: {
    width: '200px',
    color: 'white',
    fontFamily: 'Roboto',
    '& input': {
      color: 'white',
      backgroundColor: '#000A16',
      borderRadius: 6,
      border: `1px solid transparent`,
      padding: '6px 22px 7px 12px',
      width: '100%',
      height: 35,
      fontSize: 16,
    },
    '& .MuiSvgIcon-root': {
      zIndex: 1,
      cursor: 'pointer',
    },
  },
  label: {
    fontSize: 12,
  },
  dateWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingRight: '12px'
  },
  loading: {
    animationName: '$spin',
    animationDuration: '5000ms',
    animationIterationCount: 'infinite',
    animationTimingFunction: 'linear',
  },
  '@keyframes spin': {
    '0%': {
      transform: 'rotate(0deg)'
    },
    '100%': {
      transform: 'rotate(360deg)',
    }
  },
})
);

interface OwnProps {
  readonly onSetDate: (date: Date | null) => void;
  readonly site: string;
}

type Props = OwnProps;

const Datepicker = (props: Props) => {
  const { onSetDate } = props;

  const [date, setDate] = React.useState<Date | null>(null);
  const [open, setOpen] = React.useState<boolean>(false);
  const [isLoading] = React.useState(false);
  const classes = useStyles();

  const handleDateChange = (newDate: Date | null) => {
    setDate(newDate);
    onSetDate(newDate)
    setOpen(false);
  };

  // React.useEffect(() => {
  //   const getValidContestDates = async () => {
  //     const params = {
  //       sport: routeParams?.league?.toUpperCase() || '',
  //       site,
  //     }
  //     setIsLoading(true);
  //     const validDatesStringList = await fetch(`${process.env.REACT_APP_API_URL}/api/contests/getSimulatedContestsDates?` + new URLSearchParams(params)).then(res => {
  //       return res.json()
  //     });
  //     setIsLoading(false);
  //     if (validDatesStringList) {
  //       var validDates = validDatesStringList.map(x => Date.parse(x));
  //       setValidContestDates(validDates);
  //     }
  //   }
  //   if (site) {
  //     getValidContestDates();
  //   }
  // }, [routeParams, site])

  return (
    <div className={classes.formWrapper}>
      <div className={classes.dateWrapper}>
        <ReactDatepicker
          selected={date} 
          onClickOutside={() => setOpen(false)}
          onChange={(newDate) => handleDateChange(newDate)}
          onSelect={() => setOpen(false)}
          // includeDates={validContestDates}
          placeholderText='Contest Date'
          open={open}
          startOpen
          onInputClick={() => setOpen(true)}
          onCalendarClose={() => setOpen(false)}
        />
        {isLoading ? <LoopIcon className={classes.loading} /> : <EventIcon onClick={() => setOpen(!open)}/>}
      </div>
    </div>
  )
}

export default Datepicker